/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Answer,
  AnswerApplicant,
  AnswerCreatePayloadRequest,
  AnswerUpdatePayloadRequest,
  ErrorResponse,
  ValidationErrorResponse,
} from '../models';
import {
    AnswerFromJSON,
    AnswerToJSON,
    AnswerApplicantFromJSON,
    AnswerApplicantToJSON,
    AnswerCreatePayloadRequestFromJSON,
    AnswerCreatePayloadRequestToJSON,
    AnswerUpdatePayloadRequestFromJSON,
    AnswerUpdatePayloadRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models';

export interface AnswersCreateRequest {
    answerCreatePayloadRequest: AnswerCreatePayloadRequest;
}

export interface AnswersDestroyRequest {
    id: number;
}

export interface AnswersListRequest {
    attemptId?: string;
}

export interface AnswersUpdateRequest {
    id: number;
    answerUpdatePayloadRequest: AnswerUpdatePayloadRequest;
}

/**
 * 
 */
export class AnswersApi extends runtime.BaseAPI {

    /**
     */
    async answersCreateRaw(requestParameters: AnswersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnswerApplicant>> {
        if (requestParameters.answerCreatePayloadRequest === null || requestParameters.answerCreatePayloadRequest === undefined) {
            throw new runtime.RequiredError('answerCreatePayloadRequest','Required parameter requestParameters.answerCreatePayloadRequest was null or undefined when calling answersCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/answers/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AnswerCreatePayloadRequestToJSON(requestParameters.answerCreatePayloadRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnswerApplicantFromJSON(jsonValue));
    }

    /**
     */
    async answersCreate(requestParameters: AnswersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnswerApplicant> {
        const response = await this.answersCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async answersDestroyRaw(requestParameters: AnswersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling answersDestroy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/answers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async answersDestroy(requestParameters: AnswersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.answersDestroyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async answersListRaw(requestParameters: AnswersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Answer>>> {
        const queryParameters: any = {};

        if (requestParameters.attemptId !== undefined) {
            queryParameters['attemptId'] = requestParameters.attemptId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/answers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AnswerFromJSON));
    }

    /**
     */
    async answersList(requestParameters: AnswersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Answer>> {
        const response = await this.answersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async answersUpdateRaw(requestParameters: AnswersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnswerApplicant>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling answersUpdate.');
        }

        if (requestParameters.answerUpdatePayloadRequest === null || requestParameters.answerUpdatePayloadRequest === undefined) {
            throw new runtime.RequiredError('answerUpdatePayloadRequest','Required parameter requestParameters.answerUpdatePayloadRequest was null or undefined when calling answersUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["ApplicantCode"] = this.configuration.apiKey("ApplicantCode"); // ApplicantAuthentication authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/answers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AnswerUpdatePayloadRequestToJSON(requestParameters.answerUpdatePayloadRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnswerApplicantFromJSON(jsonValue));
    }

    /**
     */
    async answersUpdate(requestParameters: AnswersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnswerApplicant> {
        const response = await this.answersUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
